<template>
  <div class="searchable-select" @keydown.down.prevent="move(1)" @keydown.up.prevent="move(-1)" @keydown.enter.prevent="choose(highlighted)" @keydown.esc="close">
    <input
      v-model="query"
      type="text"
      :placeholder="placeholder"
      autocomplete="off"
      @focus="open = true"
      @input="open = true; highlight = 0"
    />
    <ul v-if="open && rows.length" class="ss-list">
      <li
        v-for="(row, i) in rows"
        :key="rowKey(row) + '-' + i"
        :class="{ 'ss-active': i === highlight }"
        @mousedown.prevent="choose(row)"
        @mouseover="highlight = i"
      >
        {{ rowLabelFn(row) }}
      </li>
    </ul>
    <div v-if="open && !rows.length" class="ss-empty">
      No matches
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchableSelect',
  props: {
    // Array of already-filtered-or-full rows to show; parent filters via `filterFn`.
    items: { type: Array, default: () => [] },
    // (row) => string label
    rowLabelFn: { type: Function, required: true },
    // (row) => string unique key
    rowKey: { type: Function, required: true },
    // (query) => filtered rows
    filterFn: { type: Function, required: true },
    placeholder: { type: String, default: 'Type to search…' },
    // Preselected label to show (edit mode)
    initialLabel: { type: String, default: '' },
  },
  data () {
    return { query: this.initialLabel, open: false, highlight: 0 }
  },
  computed: {
    rows () { return this.filterFn(this.query) },
    highlighted () { return this.rows[this.highlight] },
  },
  watch: {
    initialLabel (val) { this.query = val },
  },
  mounted () {
    this.onDocClick = (e) => {
      if (this.$el && !this.$el.contains(e.target)) this.close()
    }
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    move (delta) {
      if (!this.rows.length) return
      this.open = true
      this.highlight = (this.highlight + delta + this.rows.length) % this.rows.length
    },
    choose (row) {
      if (!row) return
      this.query = this.rowLabelFn(row)
      this.open = false
      this.$emit('select', row)
    },
    close () { this.open = false },
  },
}
</script>

<style scoped>
.searchable-select { position: relative; display: block; }
.searchable-select input { width: 100%; box-sizing: border-box; }
.ss-list {
  position: absolute; z-index: 20; left: 0; right: 0; margin: 0; padding: 0;
  list-style: none; max-height: 260px; overflow-y: auto;
  background: #fff; border: 1px solid #999; box-shadow: 0 2px 6px rgba(0,0,0,.2);
}
.ss-list li { padding: 4px 8px; cursor: pointer; white-space: nowrap; }
.ss-list li.ss-active { background: #e33; color: #fff; }
.ss-empty { position: absolute; background: #fff; border: 1px solid #999; padding: 4px 8px; }
</style>



// WEBPACK FOOTER //
// SearchableSelect.vue?4ba96bea